<template>
  <div class="base-header pr">
    <div :class="['left-side', {'has-back': showBack}]">
      <div class="btn-menu" @click="menuOpen = true"></div>
      <div class="btn-back" @click="back">
        <van-icon name="arrow-left" />
      </div>
    </div>
    <p :class="['page-title', 'pa', {show: pageTitle}]">{{pageTitle}}{{cartTitleNum}}</p>
    <img :class="['logo', 'pa', {hide: pageTitle}]" src="https://resource.rcclchina.com.cn/logo/MB/logoAnchorWhite.png" alt="logo">
    <div class="right-side">
      <div :class="['tools', {hide: menuOpen}]">
        <img src="../assets/icons/icon_service.png" alt="button service" @click="handleServiceMenuClick">
        <img src="../assets/icons/icon_phone.png" alt="button phone" @click="handlePhoneMenuClick">
        <img src="../assets/icons/icon_question.png" alt="button question" @click="handleQuestionMenuClick">
      </div>
      <a href="javascript:;" :class="['btn-close', {hide: !menuOpen}]" @click="menuOpen = false"></a>
    </div>
    <page-menu :visible="menuOpen" />
  </div>
</template>

<script>
import PageMenu from '@/views/PageMenu'
import { mapState } from 'vuex'
import { gioTracking } from '@/plugins/common'

export default {
  name: 'BaseHeader',

  components: {
    PageMenu
  },

  computed: {
    ...mapState(['goodsCartNum', 'isMiniApp']),
    showBack () {
      return this.$route.path !== '/Rccl.Pcp/Home/Index'
    },
    pageTitle () {
      return this.$route.meta.title
    },
    cartTitleNum () {
      return this.goodsCartNum && this.$route.path === '/Rccl.PCP/order/ShoppingCart' ? `(${this.goodsCartNum})` : ''
    }
  },

  watch: {
    $route () {
      this.menuOpen = false
    }
  },

  data () {
    return {
      menuOpen: false
    }
  },

  methods: {
    back () {
      if (window.history.length <= 1) {
        this.$router.replace({ path: '/' })
      } else {
        this.$router.back()
      }
    },
    async handleServiceMenuClick () {
      // window.location.href = 'https://rcclchina.udesk.cn/im_client/?web_plugin_id=75221'
      if (this.isMiniApp) {
        window.open('https://rcclchina.udesk.cn/im_client/?web_plugin_id=75221', 'newwindow')
      } else {
        window.location.href = 'https://rcclchina.udesk.cn/im_client/?web_plugin_id=75221'
      }
    },
    handlePhoneMenuClick () {
      window.location.href = 'tel:400-820-3187'
      // window.location.href = 'tel:852-6969-0717'
    },
    handleQuestionMenuClick () {
      gioTracking('track','evt_ButtonClicked',{'btnType':'FAQ'})
      this.$router.push('/page_question')
    }
  }
}
</script>

<style lang="less" scoped>
.base-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 97;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 122px;
  padding: 0 22px 0 35px;
  box-sizing: border-box;
  background-color: @main-color;
  .logo {
    top: 50%;
    left: 50%;
    z-index: 1;
    width: 60px;
    margin: -35px 0 0 -35px;
    transition: all .3s;
    &.hide {
      margin-top: -50px;
      opacity: 0;
    }
  }
  .page-title {
    top: 50%;
    left: 50%;
    z-index: 2;
    font-size: 30px;
    font-weight: bold;
    color: #fff;
    transform: translate3d(-50%, -70%, 0);
    transition: all .3s;
    &.show {
      opacity: 1;
      transform: translate3d(-50%, -50%, 0);
    }
  }
  .left-side {
    position: relative;
    width: 62px;
    height: 54px;
    overflow: hidden;
    &.has-back {
      .btn-menu {
        display: none;
      }
      .btn-back {
        display: flex;
      }
    }
    .btn-menu {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 62px;
      height: 54px;
      background: url("../assets/icons/icon_menu.png") center center no-repeat;
      background-size: 38px 30px;
    }
    .btn-back {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      display: none;
      align-items: center;
      justify-content: center;
      font-size: 48px;
      color: #fff;
    }
  }
  .right-side {
    position: relative;
    width: 240px;
    height: 78px;
    overflow: hidden;
    .btn-item {
      width: 42px;
      height: 42px;
      padding: 18px;
    }
    .tools {
      display: flex;
      align-items: center;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      transition: all .3s;
      &.hide {
        right: -234px;
      }
      img {
        .btn-item;
      }
    }
    .btn-close {
      .btn-item;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      background: url("../assets/icons/icon_close.png") center center no-repeat;
      background-size: 30px 30px;
      transition: all .3s;
      &.hide {
        right: -78px;
      }
    }
  }
}
</style>
